var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoservice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_x2C__SUV_x2C__automobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_785_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_786_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 2.917,
    x2: 1.5,
    y1: 16.5,
    y2: 16.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_787_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.917,
    x2: 28.5,
    y1: 17.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M5.764,10.621l-0.509,0.872C4.478,12.826,5.439,14.5,6.982,14.5H11.5",
    fill: "none",
    id: "XMLID_788_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_789_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.463,
    x2: 19.037,
    y1: 23.5,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M27.365,23.045L30.5,22l-0.379-4.918c-0.07-0.927-0.771-1.682-1.689-1.823L23.5,14.5l-3.718-4.055    C18.646,9.206,17.041,8.5,15.359,8.5H6.161c-0.718,0-1.381,0.385-1.737,1.008L1.5,14.629v6.731c0,0.596,0.263,1.14,0.688,1.51",
    fill: "none",
    id: "XMLID_790_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,24c0,1.93-1.57,3.5-3.5,3.5    s-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5S27.5,22.07,27.5,24z",
    fill: "none",
    id: "XMLID_791_",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,24c0,1.93-1.57,3.5-3.5,3.5S3.5,25.93,3.5,24    s1.57-3.5,3.5-3.5S10.5,22.07,10.5,24z",
    fill: "none",
    id: "XMLID_792_",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    fill: "none",
    id: "XMLID_793_",
    r: 1.5,
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 24,
    fill: "none",
    id: "XMLID_794_",
    r: 1.5,
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_795_",
    points: "    13.704,10.539 14,14.5 23.5,14.5   ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_796_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 19.5,
    x2: 11.5,
    y1: 21.5,
    y2: 21.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_797_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.917,
    x2: 28.5,
    y1: 20.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_798_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.516,
    x2: 24,
    y1: 27.5,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_799_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 1.6,
    x2: 1.5,
    y1: 27.5,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "XMLID_800_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.5,
    x2: 12.5,
    y1: 29.5,
    y2: 29.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoservice);
export default __webpack_public_path__ + "static/media/autoservice.3f11aad35b1af64f8572ca20d797f348.svg";
export { ForwardRef as ReactComponent };